export interface Option<T extends string> {
  disabled?: boolean
  label: string
  value?: T
}
export interface SelectProps<T extends string> {
  options: Option<T>[]
  value: T | ""
  label?: string
  onChange: (e: T | undefined) => void
  error?: boolean
  disabled?: boolean
  dense?: boolean
}
export default function Select<T extends string>({
  options,
  value,
  onChange,
  label,
  error,
  disabled = false,
  dense,
}: SelectProps<T>) {
  const optionsWithPlaceholder = [{ label: "Bitte auswählen", value: "", disabled: true }, ...options]
  return (
    <>
      <style jsx>{`
        .selectContainer {
          position: relative;
          justify-self: stretch;

          & label {
            position: absolute;
            font-size: 1rem;
            left: 0;
            top: 1.5rem;
            transform: translateY(-50%);
            background-color: white;
            color: ${error ? "var(--danger)" : "var(--dark)"};
            padding: 0 0.3rem;
            margin: 0 0.5rem;
            transition: 0.1s ease-out;
            transform-origin: left top;
            pointer-events: none;
            border-radius: 5px;
          }

          & select {
            background-color: white;
            appearance: none;
            width: 100%;
            font-size: 1rem;
            outline: none;
            border: 1px solid ${error ? "var(--danger)" : "var(--dark)"};
            border-radius: 10px;
            padding: 0.75rem 0.7rem;
            transition: 0.1s ease-out;
            ${dense ? "padding: 0.25rem 0.7rem;" : ""};
            &:focus {
              border-color: var(--primary);
            }
            &:focus + label {
              color: var(--primary);
              top: 0;
              transform: translateY(-50%) scale(0.9);
            }

            &:not(:invalid) + label {
              top: 0;
              transform: translateY(-50%) scale(0.9);
            }
          }
        }
      `}</style>
      <div className="selectContainer">
        <select
          name="selector"
          onChange={e => onChange(e.target.value as T)}
          value={value}
          disabled={disabled}
          required
        >
          {optionsWithPlaceholder.map(option => (
            <option key={option.value} value={option.value} disabled={option.disabled}>
              {option.label}
            </option>
          ))}
        </select>
        <label htmlFor="selector">{label}</label>
      </div>
    </>
  )
}
